import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from "../../base-component/base-component";

import DefaultMoreComponent from "./more-component";

const propTypes = {
    optionComponent: PropTypes.func.isRequired,
    moreComponent: PropTypes.func,

    options: PropTypes.array,
    max: PropTypes.number,
    value: PropTypes.string,
    disabled: PropTypes.bool,

    showMore: PropTypes.bool,
    moreAddLabel: PropTypes.string,

    onClickAdd: PropTypes.func,
    onChange: PropTypes.func
};

const defaultProps = {
    max: null
};


class Selector extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };

        this._bind('onOptionClick');
    }

    // change state if new props
    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.value !== this.state.value) this.setState({value: newProps.value});
    }

    onOptionClick(id) {
        const { disabled, onChange } = this.props;
        if ( disabled ) return;

        if (!id) id = 'all';

        this.setState({
            value: id
        }, ()=>{
            if (onChange) onChange(id);
        });
    }

    render() {
        const { options, optionComponent: OptionComponent, moreComponent, max, disabled, showMore, moreAddLabel,
            onClickAdd, className } = this.props;
        const componentClasses = Classes('gd-selector2', className, {
            disabled: disabled
        });

        let visibleOptions = options.slice();
        let moreOptions = [];
        if (max && visibleOptions.length > max) moreOptions = visibleOptions.splice(max);

        const MoreComponent = moreComponent ? moreComponent : DefaultMoreComponent;

        return (
            <div className={componentClasses}>
                {visibleOptions.map(o=><OptionComponent key={o.value}
                                                        value={o.value}
                                                        icon={o.icon}
                                                        iconObj={o.iconObj}
                                                        label={o.label}
                                                        isSelected={o.value === this.state.value}
                                                        parent={this}/>)}

                {showMore && moreOptions.length > 0 &&
                <MoreComponent optionComponent={OptionComponent}
                               options={moreOptions}
                               addLabel={moreAddLabel}
                               onUserSelect={this.onOptionClick}
                               onClickAdd={onClickAdd}/>}

                <div className="cf"> </div>
            </div>
        );
    }
}

Selector.propTypes = propTypes;
Selector.defaultProps = defaultProps;

module.exports = Selector;